"use client";

import { createContext, useContext } from "react";

// Mode context - widgets read this to adapt their layout.
//   'compact' = small widget tile (fixed 317x317)
//   'canvas'  = expanded inside chat (max-height: 60vh)
//   'modal'   = fullscreen Cstretchmodal (fill the available space)
export const CMARKDOWNVISUAL_MODE = {
  Compact: "compact",
  Canvas: "canvas",
  Modal: "modal",
} as const;

export type CmarkdownvisualMode =
  (typeof CMARKDOWNVISUAL_MODE)[keyof typeof CMARKDOWNVISUAL_MODE];

const CmarkdownvisualContext = createContext<{ mode: CmarkdownvisualMode }>({
  mode: CMARKDOWNVISUAL_MODE.Canvas,
});

export const CmarkdownvisualModeProvider = CmarkdownvisualContext.Provider;

export function useCmarkdownvisualMode(): CmarkdownvisualMode {
  return useContext(CmarkdownvisualContext).mode;
}
